// extracted by mini-css-extract-plugin
module.exports = {"main":"Section-module--main--j1NB5","alt":"Section-module--alt--11ZH1","padding":"Section-module--padding--gC35a"};